import React from 'react';
import { useInscriptionConversation, type InscriptionKind } from '../../hooks/useInscriptionConversation';
import { AtnaDialogShell } from '../atna/AtnaDialogShell';
import { InscriptionMessage } from './InscriptionMessage';
interface InscriptionDialogProps {
  initialText: string;
  onClose: () => void;
  /** Shared layout id: the launcher pill morphs into this panel. */
  layoutId: string;
}
export function InscriptionDialog({
  initialText,
  onClose,
  layoutId
}: InscriptionDialogProps) {
  const {
    turns,
    thinking,
    draft,
    setDraft,
    submitDraft,
    category,
    slots,
    slot,
    pickCategory,
    register,
    restart,
    liveAtnaId,
    lastAtnaKind
  } = useInscriptionConversation(initialText);
  return <AtnaDialogShell layoutId={layoutId} subtitle="Program registration" onClose={onClose} turns={turns} thinking={thinking} liveAtnaId={liveAtnaId} footnote="ATNA can make mistakes. Check the schedule before confirming a registration." prompt={{
    value: draft,
    onChange: setDraft,
    onSubmit: submitDraft,
    placeholder: lastAtnaKind === 'confirmation' ? 'Register for another activity?' : 'Name an activity, for example “swim lessons”…'
  }} renderAtna={(kind, live) => <InscriptionMessage kind={kind as InscriptionKind} live={live} category={category} slots={slots} slot={slot} onPickCategory={pickCategory} onRegister={register} onRestart={restart} data-id="element-1427" data-mp="dcsgk0nyrdyx" />} data-id="element-1426" data-mp="97832jur8l6c" />;
}